import React from 'react';
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';

class StockForecast extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: false,
			forecastCurrent: ''
		};
	}

	toggleSelect = () => {
		if (!this.props.loading) {
			this.setState({dropdownOpen: !this.state.dropdownOpen})
		}
	}

	onClick = (forecast) => {
		this.setState({forecastCurrent: forecast});
		this.props.updateForecast(forecast);
	}

	render() {
		const {dropdownOpen, forecastCurrent} = this.state;
		return (
			<Dropdown isOpen={dropdownOpen} toggle={this.toggleSelect}>
				<DropdownToggle caret>
					{this.props.loading ? "Loading" : forecastCurrent === '' && this.props.forecastOptions ?
						this.props.forecastOptions[0] : forecastCurrent}
				</DropdownToggle>
				<DropdownMenu>
					<DropdownItem header>Stock Forecast</DropdownItem>
					{this.props.forecastOptions && this.props.forecastOptions.map(f => {
						return (
							<DropdownItem key={f} onClick={() => this.onClick(f)}>
								{f}
							</DropdownItem>
						);
					})}
				</DropdownMenu>
			</Dropdown>
		);
	}
}

export default StockForecast;
